module.exports = __webpack_public_path__ + "img/44-l.8830e6d5.png";